import React from "react";

// A stale or interrupted route download should offer recovery, not a blank page.
export default class RouteLoadingBoundary extends React.Component<
  { children: React.ReactNode }, { failed: boolean }
> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (this.state.failed) {
      return <div className="route-loading" role="alert">
        <p>This page could not load. Check your connection and try again.</p>
        <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>Reload page</button>
      </div>;
    }
    return this.props.children;
  }
}
